export const wssUrl = "wss://ambulance.thearay.net/api/ws/websocket/data"; // websocket 地址
export const baseUrl = "https://ambulance.thearay.net/api";
export const srsUrl = "https://ambulance.thearay.net/"; // webrtc视频地址 请求地址
export const srsRtcUrl = "webrtc://ambulance.thearay.net/"; // webrtc视频地址 播放地址
export const sseUrl = process.env.VUE_APP_BASE_API; // sse地址
export const defaultLonLati = [116.379028, 39.865042]; // 默认的地图经纬度
export const defaultAddress = "北京市"; // 默认的地图位置

export const getAmbulanceStageStatus = {
  0: "收到报文",
  1: "出车时刻",
  2: "抵达现场",
  3: "患者上车",
  4: "到达医院"
};
export const carStageTime = {
  0: "formatTime",
  1: "turout_time",
  2: "arrived_time",
  3: "board_time",
  4: "done_time",
};
export const userIds = { 1: "管理员", 2: "急救医生", 3: "主任护士" };

import axios from "axios";
// 调动高德API接口,把经纬度转换成地址
const key = "3f9ea505b916bcdc7b403e866f39c176"; // 高德key (前端去请求会不会很危险?)

// 导航界面, 急救车具体的位置转换成经纬度
export async function AddressTolongLati(address) {
  const url = `https://restapi.amap.com/v3/geocode/geo?address=${address}&key=${key}`;
  const { data } = await axios.get(url);
  const { status, info, geocodes } = data;
  if (status) {
    return geocodes[0].location;
  } else {
    throw Error(info);
  }
}

// 导航界面, 急救车当前位置经纬度转换成具体的位置
export async function longLatiToAddress(longitude, Latitude) {
  const url = `https://restapi.amap.com/v3/geocode/regeo?location=${longitude},${Latitude}&key=${key}`;
  const { data } = await axios.get(url);
  const { status, info, regeocode } = data;
  if (status) {
    return regeocode.formatted_address;
  } else {
    throw Error(info);
  }
}

// 信息管理页面 增加患者信息的时候, 点击地址的时候, 变成搜索附近地址
export async function SearchNeighbour(neighbour) {
  const url = `https://restapi.amap.com/v3/assistant/inputtips?keywords=${neighbour}&key=${key}&extensions=all&children=1`;
  const { status, data } = await axios.get(url);
  console.log(status);
  if (status === 200) {
    return data;
  }
}

// 导航页面 驾车路径规划
export async function SearchDrivingStrategy(form) {
  const { origin, destination, strategy } = form;
  const url = `https://restapi.amap.com/v3/direction/driving?origin=${origin}&destination=${destination}&key=${key}&extensions=all&strategy=${strategy}`;
  const { status, data } = await axios.get(url);
  if (status === 200) {
    const { status, info, route } = data;
    if (status) {
      return route;
    } else {
      throw Error(info);
    }
  }
}
